// @flow
import React, { useEffect, useState } from "react";
import { Dropdown, FormControl } from "react-bootstrap";
import InfoMessage from "../InfoMessage/InfoMessage";
import "./drop-down-menu.scss";

type Option = {
  title: string,
  selected?: boolean,
  visible?: boolean,
};

type Props = {
  className: string,
  variant?: string,
  onChangeValue: Function,
  menu: Array<Option>,
  title?: string,
  isActivityLog?: boolean,
  infoMessage?: string,
  fromQuestionnaire?: boolean,
};

export default function DropDownMenu({
  className,
  infoMessage,
  onChangeValue,
  menu,
  title,
  isActivityLog = false,
  fromQuestionnaire = false,
}: Props): React$Element<any> {
  const [selectedValue, setSelectedValue] = useState<Option | null>(
    menu.find((m) => m.selected) || (isActivityLog ? menu[0] : null)
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    if (fromQuestionnaire) {
      setSelectedValue(
        menu.find((m) => m.selected) || (isActivityLog ? menu[0] : null)
      );
    }
  }, [menu]);

  const displayTitle = (selectedValue && selectedValue.title) ? (
    <span style={{ color: "black" }}>{selectedValue.title}</span>
  ) : (
    title
  );

  const onInputChange = (newValue: Option | null) => {
    if (newValue) {
      setSelectedValue(newValue);
      onChangeValue(newValue || {});
      setShowMenu(false);
    }
  };

  const filteredMenu = menu
    .filter((option) => {
      const lowerCaseTitle = option?.title?.toLowerCase();
      const lowerCaseSearchTerm = searchTerm.toLowerCase();

      return lowerCaseTitle.startsWith(lowerCaseSearchTerm) || lowerCaseTitle.includes(lowerCaseSearchTerm);
    })
    .sort((a, b) => {
      const aStartsWith = a.title.toLowerCase().startsWith(searchTerm.toLowerCase());
      const bStartsWith = b.title.toLowerCase().startsWith(searchTerm.toLowerCase());

      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;
      
      return 0;
    });

  const renderOptions = () =>
    filteredMenu.map((option, index) => (
      <Dropdown.Item
        key={index}
        onClick={() => onInputChange(option)}
        active={option === selectedValue}
      >
        {option.title}
      </Dropdown.Item>
    ));

  const onFocusOut = () => {
    if (!selectedValue && isActivityLog) {
      setSelectedValue(menu[0]);
    }
  };

  return (
    menu && (
      <div
        className={`dropdownmenu ${className} ${
          isActivityLog && "activity-log-dropdown"
        }`}
      >
        <Dropdown
          onToggle={(isOpen) => setShowMenu(isOpen)}
          show={showMenu}
          autoFocus={true}
          onBlur={onFocusOut}
        >
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {showMenu ? (
              <FormControl
                autoFocus={true}
                className="placeholder_div"
                placeholder="Type to search..."
                onChange={(e) => setSearchTerm(e.currentTarget.value)}
                value={searchTerm}
              />
            ) : (
              <div className="displaytitle_div" >{ displayTitle || "Select an option"}</div>
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu>{renderOptions()}</Dropdown.Menu>
        </Dropdown>
        {infoMessage && <InfoMessage text={infoMessage} />}
      </div>
    )
  );
}


